import React from 'react'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import '../BookingHistory/AirCargoList.css'

// Page tokens for the pagination bar, e.g. [1, "…", 4, 5, 6, "…", 20]
// (same windowing as AirCargoList).
const buildPageWindow = (current, total) => {
    if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1)
    const pages = []
    const add = (n) => { if (pages[pages.length - 1] !== n) pages.push(n) }
    add(1)
    if (current > 3) add('…')
    for (let i = Math.max(2, current - 1); i <= Math.min(total - 1, current + 1); i++) add(i)
    if (current < total - 2) add('…')
    add(total)
    return pages
}

/**
 * Amber pagination bar used under the booking/credit tables (bq-* styles from
 * AirCargoList.css). Renders nothing when there are no rows.
 *
 * @param {number}   page      - current page (1-based)
 * @param {number}   pageSize  - rows per page
 * @param {number}   total     - total rows
 * @param {string}   [itemLabel='records'] - noun in "1–10 of 45 <itemLabel>"
 * @param {Function} onChange  - (page, pageSize) => void
 */
const TablePagination = ({ page, pageSize, total, itemLabel = 'records', onChange }) => {
    if (!total) return null
    const pageCount = Math.max(1, Math.ceil(total / pageSize))
    const fromIdx = (page - 1) * pageSize + 1
    const toIdx = Math.min(page * pageSize, total)
    return (
        <div className="bq-pagination">
            <span className="bq-page-info">
                {fromIdx}–{toIdx} of {total.toLocaleString()} {itemLabel}
            </span>
            <div className="bq-page-controls">
                <select
                    className="bq-page-size-select"
                    value={pageSize}
                    onChange={(e)=> onChange(1, Number(e.target.value))}
                >
                    {[10, 20, 50].map((n)=> (
                        <option key={n} value={n}>{n} / page</option>
                    ))}
                </select>
                <button
                    className="bq-page-btn"
                    disabled={page <= 1}
                    onClick={()=> onChange(page - 1, pageSize)}
                >
                    <ChevronLeft size={14} />
                </button>
                {buildPageWindow(page, pageCount).map((p, i)=>
                    p === '…' ? (
                        <span key={`e${i}`} className="bq-page-ellipsis">…</span>
                    ) : (
                        <button
                            key={p}
                            className={`bq-page-num-btn${p === page ? ' active' : ''}`}
                            onClick={()=> onChange(p, pageSize)}
                        >
                            {p}
                        </button>
                    )
                )}
                <button
                    className="bq-page-btn"
                    disabled={page >= pageCount}
                    onClick={()=> onChange(page + 1, pageSize)}
                >
                    <ChevronRight size={14} />
                </button>
            </div>
        </div>
    )
}

export default React.memo(TablePagination)
